// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";

import "./src/jquery";

import * as bootstrap from "bootstrap";
import "./controllers";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

window.adminlte = require("./src/adminlte.js");

import { OverlayScrollbars } from "overlayscrollbars";

require("@nathanvda/cocoon");
